import axios from 'axios';
import { API_BASE_URL } from './client';

/**
 * 테이블오더 고객용(게스트) 화면 전용 axios 인스턴스.
 * client.js 의 인터셉터(관리자 토큰 자동 첨부, 401 시 관리자 로그인 화면으로 리다이렉트)를
 * 그대로 쓰면 게스트에게 전혀 맞지 않는 동작(로그인 화면 이동)이 발생할 수 있어 분리했다.
 * 테이블오더 공개 API는 QR 토큰(쿼리 파라미터)만으로 식별되며 인증 헤더가 필요 없다.
 */
const publicClient = axios.create({
  baseURL: API_BASE_URL,
});

export default publicClient;
